import { black } from '../../constants/Colors';

export const baseDefaultProps = {
    textColor: black,
    fontStyle: 'normal',
    letterSpacing: 'normal',
};
